(function() {
    // 注册组件
    SR.component.extend('swiperContent', swiperContent);

    function swiperContent(options) {
        var data = options.data;
        var $el = $(options.element);
        var contentSwiper = new Swiper($el[0], {
            autoHeight: true,
            pagination : '.swiper-pagination',
            paginationClickable :true,
            loop: true,
        });
    }
})();
